import { connect } from 'react-redux'
import toJS from '../general/toJS'
import CollectionsList from '../../components/PageEditSelection/CollectionsList'
import getData from '../../functions/getData'
import { PROGRAM_SELECTIONS_ITEMS } from '../../constants/state'

const mapStateToProps = (state, ownProps) => ({
    collections: getData(state, PROGRAM_SELECTIONS_ITEMS).getIn([ownProps.selectionID, 'collections']),
    selectionsCinema: getData(state, PROGRAM_SELECTIONS_ITEMS).getIn([ownProps.selectionID, 'cinema']),
    selectionsCinemasFilter: getData(state, PROGRAM_SELECTIONS_ITEMS).getIn([ownProps.selectionID, 'cinemasFilter'])
})

const CollectionsListContainer = ({
    selectionID,
    selectionType, 
    collections, 
    filterType, 
    filterValue, 
    selectionsCinema, 
    selectionsCinemasFilter
}) => <CollectionsList
    selectionID={selectionID}
    selectionType={selectionType}
    collections={collections}
    filterType={filterType}
    filterValue={filterValue}
    selectionsCinema={selectionsCinema}
    selectionsCinemasFilter={selectionsCinemasFilter}
/>

export default connect(mapStateToProps, null)(toJS(CollectionsListContainer))